import { DndProvider } from 'react-dnd'
import { HTML5Backend } from 'react-dnd-html5-backend'

export default function DragAndDropProvider({ children }) {
  return (
    <DndProvider backend={HTML5Backend}>
      {children}
    </DndProvider>
  )
}

export const ItemTypes = {
    WIDGET: 'widget',
    WIDGET_GROUP: 'widget-group',
    Card : 'card'

}